import React from 'react'
import styles from './NotFound.module.scss'

function NotFound() {
  return (
    <div className={styles.notFound}>
      <h3>Sorry, page not found!</h3>
    </div>
  )
}

export default NotFound
